function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var instance = null;

var ListenerDocumentClick = /*#__PURE__*/function () {
  function ListenerDocumentClick() {
    _classCallCheck(this, ListenerDocumentClick);

    if (!instance) {
      instance = this;
    }

    return instance;
  }

  _createClass(ListenerDocumentClick, [{
    key: "emmit",
    value: function emmit(e) {
      //e.preventDefault();
      this._unbind();

      if (this.onEmmit != null) {
        this.onEmmit();
      }
    }
  }, {
    key: "onEmmit",
    value: function onEmmit() {}
  }, {
    key: "_bind",
    value: function _bind() {
      document.addEventListener("click", this);
    }
  }, {
    key: "_unbind",
    value: function _unbind() {
      document.removeEventListener("click", this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      this.emmit(e);
    }
  }]);

  return ListenerDocumentClick;
}();

export { ListenerDocumentClick as default };